<template>
    <div>
      <UserProfileAccount />
      <!-- <UserProfilePrivacy /> -->
    </div>
</template>

<script>
import UserProfileAccount from './UserProfileAccount.vue';
// import UserProfilePrivacy from './UserProfilePrivacy.vue';

export default {
  name: 'UserTest',
  components: {
    UserProfileAccount,
    // UserProfilePrivacy,
  },
};
</script>
